import {action, observable} from 'mobx';
import axios from 'axios';
axios.defaults.withCredentials = true;
class Store {
    // 楼层导航展开状态
    @observable floorSpread = false;

    @observable renderData = {
        'bg': {data: {}},
        'bkhd': {},
        'mstj': {},
        'amorous': {},
        'rqgl': {},
        'txzsyj': {},
        'jqwlnr': {},
        'jqwlbq': {},
        'whbdcp': {},
        'whbdbq': {},
        'hdzxbq': {},

        'rmjq': {},
        'tjjd': {},
        'jpxl': {},
        'jqhd': {},
        'slbdbq': {},
        'fqwlbq': {},
        'rmtj': {},
        'economic_area_introduction': {},
        'economic_area_product_tab': [],
        'handbook': [],
        'lysc': []
    };

    // 视频弹框
    @observable displayVideo = false;
    @observable couponList = [];

    @observable scrollTop = 0; // 记录页面滚动位置

    // 视频地址
    @observable curVideoUrl = '';
    @action.bound toggleSpread() {
        this.floorSpread = !this.floorSpread;
    }

    // 展示弹窗
    @action.bound showPopup(url = '') {
        this.curVideoUrl = url;
        this.displayVideo = true;
        this.stopBodyScroll(true);
    }

    // 关闭弹窗
    @action.bound hidePopup() {
        this.curVideoUrl = '';
        this.displayVideo = false;
        this.stopBodyScroll(false);
    }

    @action.bound getScrollTop(val) {
        this.scrollTop = val;
    }

    // flag -> true/false  阻止/允许页面滚动
    @action.bound stopBodyScroll(isFixed) {
        if (isFixed) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'visible';
        }
    }

    // 请求数据
    @action.bound requestData() {
        // const api = '//oss.dujia.qunar.com/cg/detail?pos=s_zjyjxj&modules=rqgl,fqwlbq,bg,slbdbq,txzsyj,js,mstj,hb';
        if(this.loaded) return;
        const api = '//oss.dujia.qunar.com/cg/detail?pos=s_dlwlj22&modules=jqwlnr,rqgl,spjs,bg,txzsyj,jqwlbq,whbdbq,hdzxbq,bkhd,mstj,rmtj,economic_area_introduction,economic_area_product_tab,handbook,lysc';
        axios.get(api)
            .then(res => res.data)
            .then(res => {
                const {status, data} =res;
                this.loaded = true;
                if(!status) {
                    Object.keys(data).forEach(key => {
                        if (!Array.isArray(data[key]) || !data[key].length) {
                            return;
                        }
                        switch (key) {
                            case 'whbdbq':
                            case 'jqwlbq':
                                this.renderData[key] = data[key];
                                break;
                            case 'hdzxbq':
                                this.renderData[key] = data[key];
                            case 'spjs':
                                if (data[key][0] && data[key][0].data && data[key][0].data.length) {
                                    this.renderData.amorous = data[key][0].data[0];
                                }
                                break;
                            case 'bg':
                                this.renderData.bg = data[key][0];
                                break;
                            case 'economic_area_introduction':
                            case 'handbook':
                            case 'lysc':
                                this.renderData[key] = data[key] && data[key][0].data && data[key][0].data;
                                break;
                            case 'economic_area_product_tab' :
                                this.renderData[key] = data[key];
                                break;
                            default:
                                this.renderData[key] = data[key][0];
                        }
                    });
                }
            });
    }
}

export default new Store();